const ssoGTMid = 'GTM-NDPQMWJ';

const getGtmDomain = (): string => {
  const domain = window.location.hostname.split('.')[1];
  const gtmBrands = ['telia', 'diil', 'super', 'teliatv'];

  return gtmBrands.includes(domain) ? domain : 'telia';
};

const gtmUrl = `https://cat.${getGtmDomain()}.ee`;

export const addSsoGtmScript = (): void => {
  const existingSsoGtmScript = getGtmScript();

  if (!existingSsoGtmScript) {
    const gtmScript = document.createElement('script');
    gtmScript.setAttribute('src', `${gtmUrl}/gtm.js?id=${ssoGTMid}`);
    gtmScript.setAttribute('async', 'true');
    document.head.insertBefore(gtmScript, document.head.childNodes[0]);
  }
};

const getGtmScript = (): Element | null => {
  return document.querySelector(`script[src^="${gtmUrl}/gtm.js?id=${ssoGTMid}"]`);
};

export const injectSsoPortalRoot = () => {
  if (document.getElementById('sso-portal-root')) {
    return;
  }
  const ssoPortalRoot = document.createElement('div');
  ssoPortalRoot.id = 'sso-portal-root';
  ssoPortalRoot.style.cssText = 'overflow: visible; position: static';
  ssoPortalRoot.className = 'sso-root';
  document.body.appendChild(ssoPortalRoot);
};

export const cleanUpSsoPortalRoot = () => {
  const ssoPortalRoot = document.getElementById('sso-portal-root');
  if (ssoPortalRoot) {
    document.body.removeChild(ssoPortalRoot);
  }
};

export const injectSsoCss = (fileNames: string[]) => {
  fetch('/static/manifest-new.json')
    .then((res) => res.json())
    .then((manifest) => {
      fileNames.forEach((fileName) => {
        if (document.querySelector(`link[href^="/css/${fileName}"]`)) {
          return;
        }
        const cssElement = document.createElement('link');
        cssElement.rel = 'stylesheet';
        cssElement.type = 'text/css';
        cssElement.href = `${manifest[`${fileName}.css`]}`;
        document.head.appendChild(cssElement);
      });
    })
    .catch((err) => console.error(err));
};

export const injectModuleSsoCss = (fileNames: string[]) => {
  fetch('/sso/static/manifest-new.json')
    .then((res) => res.json())
    .then((manifest) => {
      fileNames.forEach((fileName) => {
        if (document.querySelector(`link[href^="/sso/css/${fileName}"]`) || !manifest[`${fileName}.css`]) {
          return;
        }
        const cssElement = document.createElement('link');
        cssElement.rel = 'stylesheet';
        cssElement.type = 'text/css';
        cssElement.href = `/sso${manifest[`${fileName}.css`]}`;
        document.head.appendChild(cssElement);
      });
    })
    .catch((err) => console.error(err));
};
